document.addEventListener("DOMContentLoaded", function() {
    const loginForm = document.querySelector('#customer_login');
    const buttonLoginForm = document.querySelector('#btn_modal_login');
    const buttonRegisterForm = document.querySelector('#btn_modal_register');
    const errorWrapper = document.querySelector('#CustomerLoginForm .form-errors');
    
    function createAccount(firstName, lastName, email, password, token) {  
        var data = {
            'h-captcha-response': token,
            'customer[first_name]': firstName,
            'customer[last_name]': lastName,
            'customer[email]': email,
            'customer[password]': password,
            form_type: 'create_customer',
            utf8: '✓',
        };
    
        var promise = $.ajax({
            url: 'https://mygemma.com/account',
            method: 'post',
            data: data,
            dataType: 'html',
            async: true
        });
    
        return promise;
    }

    function login(email, password, token) {  
        var data = {
            'h-captcha-response': token,
            'customer[email]': email,
            'customer[password]': password,
            form_type: 'customer_login',
            utf8: '✓',
        };
        
        var promise = $.ajax({
            url: 'https://mygemma.com/account/login',
            method: 'post',
            data: data,
            dataType: 'html',
            async: true
        });
        
        return promise;
    }


    // Forcing CAPTCHA wire up to a form
    window.Shopify.captcha.protect(loginForm, () => {});
    
    
    // Run the CAPTCHA widget when form is submitted
    buttonLoginForm.addEventListener('click', function(e) {
        e.preventDefault();

        const widgetID = '';
        hcaptcha.execute(widgetID, { async: true })
        .then(({ response, key }) => {
            
            login(document.getElementById('CustomerEmail').value, document.getElementById('CustomerPassword').value, response).done(function (html) {  
                    if (html.indexOf('Incorrect email or password.') !== -1) {
                        errorWrapper.innerHTML = errorMsg;
                    } else {
                        const matches = html.match(/{"page":{"customerId":(\d+)}}/);
                        if(matches && matches[1]) {
                            ShopifyAnalytics.meta.page.customerId = matches[1];
                            processAddWishlist();
                        } else {
                            errorWrapper.innerHTML = errorMsg;
                        }
                    }
                });            
        })
        .catch(err => {
            console.error(err);
        });

    }, false);

    // Run the CAPTCHA widget when form is submitted
    buttonRegisterForm.addEventListener('click', function(e) {
        e.preventDefault();

        const widgetID = '';
        hcaptcha.execute(widgetID, { async: true })
        .then(({ response, key }) => {
            
            createAccount(
                document.getElementById('FirstName').value, 
                document.getElementById('LastName').value, 
                document.getElementById('CustomerEmail').value, 
                document.getElementById('CustomerPassword').value, 
                response).done(function (html) {  
                    if (html.indexOf('Incorrect email or password.') !== -1) {
                        errorWrapper.innerHTML = errorMsg;
                    } else {
                        const matches = html.match(/{"page":{"customerId":(\d+)}}/);
                        if(matches && matches[1]) {
                            ShopifyAnalytics.meta.page.customerId = matches[1];
                            processAddWishlist();
                        } else {
                            errorWrapper.innerHTML = errorMsg;
                        }
                    }
                });            
        })
        .catch(err => {
            console.error(err);
        });

    }, false); 

    function processAddWishlist() {

        const elem = $('.iwishAdding');        

        elem.removeClass('iwishAdding');
        elem.removeClass('iwishAdded');

        // process from product info page
        if(jQuery('body').hasClass('template-product')) {
            
            var iWishvId = elem.parents(iwishWrapperClass).find(iWishVarSelector).val();

            iwish_add(elem, iWishvId);      
            
            if(elem.closest('.product-actions').hasClass('unavailable')) {
                
                const onhold = elem.hasClass('onhold');

                wishlistNotifyRequest(iWishvId, ShopifyAnalytics.meta.page.customerId, onhold);  
                wishlistNotifySuccessMessage(elem);
            }            


        // process from listing page
        } else {
            
            const elemWrapper = elem.closest('.group');

            var iWishvId = elem.attr("data-variant");

            $('.iWishView').addClass('clicked');
            iwish_addCollection(elem, iWishvId);

            // sold out wishlist notify:  request to remote server to send the email notification
            if(elemWrapper.hasClass('product-price--sold-out') || elem.hasClass('product-price--sold-out')) {
                const onhold = elemWrapper.hasClass('onhold') || elem.hasClass('onhold');

                wishlistNotifyRequest(iWishvId, ShopifyAnalytics.meta.page.customerId, onhold);
                elemWrapper.find('.sold-out-wishlist-btn').addClass('sold-out-wishlist-added');

                wishlistNotifySuccessMessage(elem);
            }
        }

        modalLoginPopupClose();
    }

    function modalLoginPopupClose() {
        $('#login-modal').hide();
    }

    jQuery('#login_modal_close').click(function (e) {
        modalLoginPopupClose();
    });

});



function wishlistNotifySuccessMessage(elem) {
    const successMessageSold = 'Thanks! Our team will notify you when a similar item becomes available.';
    const successMessageHold = 'Thanks! Our team will notify you if this item becomes available again.';
    const onhold = elem.hasClass('onhold') || elem.closest('.product-card').hasClass('onhold');
    const successMessage = onhold ? successMessageHold : successMessageSold;

    elem.closest('div').find('.notify-message').text(successMessage);
}